import { db } from "../firebase/config";
import { collection, doc, addDoc, updateDoc, deleteDoc, onSnapshot, arrayUnion } from "firebase/firestore";

// Listen to all inventory items in real-time
export function subscribeToInventory(callback) {
  return onSnapshot(collection(db, "inventory"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    // Sorting isn't strictly defined globally for inventory, but we can sort by PO Number
    list.sort((a, b) => (b.poNumber || "").localeCompare(a.poNumber || ""));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to inventory:", error);
    callback([], error);
  });
}

// Add a new inventory item
export async function addInventoryItem(itemData) {
  const docRef = await addDoc(collection(db, "inventory"), itemData);
  return docRef.id;
}

// Update an existing inventory item
export async function updateInventoryItem(id, itemData) {
  const docRef = doc(db, "inventory", id);
  await updateDoc(docRef, itemData);
}

// Delete an inventory item
export async function deleteInventoryItem(id) {
  const docRef = doc(db, "inventory", id);
  await deleteDoc(docRef);
}

// Append a log to an inventory item
export async function appendInventoryLog(id, logData) {
  const docRef = doc(db, "inventory", id);
  await updateDoc(docRef, {
    logs: arrayUnion({
      ...logData,
      timestamp: new Date().toISOString()
    })
  });
}
